<template>
	<div>
	<h6>{{$t('routine_analyses.deviation_devices')}}</h6>
		<div>
			<div class="row">
          		<div class="col s2">
	          		{{$t('routine_analyses.order')}}:
	          	</div>
	          	<div class="col s6">
					<select v-model="orderby">
						<option value="number">{{$t('routine_analyses.by_device_number')}}</option>
						<option value="conditions_asc">{{$t('routine_analyses.from_the_lowest_activity')}}</option>
						<option value="conditions_desc">{{$t('routine_analyses.from_the_highest_activity')}}</option>
					</select>
				</div>
			</div>
			 <col-chart :devices="devices" :inspections="inspections" :color="color" :orderby='orderby' mode='stddev'/>
	</div>
	</div>
</template>
<script>
export default {
	data: function () {
	    return {
	    	orderby: 'number'
	    }
	},
	props: {
        inspections: Object,
        devices: Object,
        color: String
    },
}
</script>
<style scoped></style>